'use strict';

function MultiColumnLayout() {
  $(".field--name-field-title").matchHeight();
  $(".field--name-field-summary").matchHeight();
};
export default MultiColumnLayout;
